import * as React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  return <section data-section-id="258273" id="high-conviction-alpha" className="relative overflow-hidden bg-background text-foreground pt-24 pb-16 md:pt-32 md:pb-24">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 text-center">
        {}
        

        {}
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 font-default text-foreground">
          Independent Alpha for the<br className="hidden md:block" /> Modern Investor<span className="text-primary">.</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 font-sans leading-relaxed">
          High-conviction opportunities in crypto and equities. We provide the analysis retail traders need to navigate complex markets with institutional clarity.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Link to="/HomePage">
            
          </Link>
        </div>

        {}
        <div className="max-w-5xl mx-auto relative">
          {}
          <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />
          
          
        </div>
      </div>
    </section>;
}